const routes = [
    {
        path: "/exam/definitions",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    },
    {
        path: "/exam/definitions/:id",
        component: () => import("../pages/AddExamEntrance.vue"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
